module.exports = __webpack_public_path__ + "static/media/user-icon.7be2c0a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-icon.svg
// module id = 251
// module chunks = 0